import { createRouter, createWebHashHistory } from "vue-router";
//基础理由
const route = [
  {
    path: "/",
    name:"Index",
    redirect: { name: "home" }, // 重定向
    component: () => import("@/views/IndexPage.vue"),
    children: [
      {
        path: '/home',
        name: "home",
        meta: { title: "首页" },
        component: () => import("@/views/HomePage.vue"),//首页
      },
      {
        path: "/phone",
        name: "phone",
        meta: { title: "墙面检测" },
        component: () => import("@/views/PhOne.vue"),// 检测页面
      },
      {
        path: "/erweima",
        name: "erweima",
        meta: { title: "二维码" },
        component: () => import("@/views/ErWeima.vue"),// 二维码
      },
    ]
  },
  
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("@/views/LoGin.vue"),
  // },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes: route,
});

export default router;